export default __webpack_public_path__ + "static/media/Avatar-2.6decc635.svg";